import styled from "styled-components";
import { Link } from "react-router-dom";

export const Ul = styled.ul`
    list-style: none;
    display: none;
    flex-flow: row nowrap;
    li {
        padding: 18px 10px;
        text-align: center;
        list-style: none;
        a {
            color: black;
        }
        h1 {
            color: black;
        }
    }
    @media (max-width: 800px) {
        transform: ${({ open }) =>
            open ? "translateY(1px)" : "translateY(3px)"};
        display: ${({ open }) => (open ? "flex" : "none")};
        flex-direction: column;
        min-height: 100px;
        box-shadow: 6px 10px 4px rgba(0, 0, 0, 0.15);
        margin-bottom: 10px;
        transition: all 0.45s ease-out;
        justify-content: space-around;
        align-items: center;
        li {
            color: #fff;
        }
    }
`;
export const LiA = styled(Link)`
    text-decoration: none;
    padding: 0.5rem;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.white};
    &:hover {
        cursor: pointer;
        transition: all 0.2s ease-out;
        opacity: 0.8;
    }
`;

export const Button = styled(Link)`
    text-decoration: none;
    border: none;
    padding: 0.5rem;
    background: none;
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.white};
    &:hover {
        cursor: pointer;
        transition: all 0.2s ease-out;
        opacity: 0.8;
    }
`;
